jQuery( $ => {
	if ( typeof QalaB2bWholesaleCheckoutFields === 'undefined' ) {
		return;
	} // this should only run on the checkout page.
	const disabledFields = window?.QalaB2bWholesaleCheckoutFields?.disabledFields || [];

	function setCustomError( message ) {
		const $errorDiv = $( '<div class="checkout-error">' ).text( message );
		$( '.checkout.woocommerce-checkout' ).prepend( $errorDiv );
	}

	let hasError = false;

	disabledFields.forEach( field => {
		const $input = $(
			`.woocommerce-billing-fields .validate-required input[name="${ field }"], .woocommerce-shipping-fields .validate-required input[name="${ field }"]`
		);
		if ( ! $input.val() && $input.hasClass( 'qala-b2b-wholesale-disabled' ) ) {
			hasError = true;
		}
	} );

	if ( ! hasError ) {
		disabledFields.forEach( field => {
			const $select = $(
				`.woocommerce-billing-fields .validate-required select[name="${ field }"], .woocommerce-shipping-fields .validate-required select[name="${ field }"]`
			);
			if ( ! $select.val() && $select.hasClass( 'qala-b2b-wholesale-disabled' ) ) {
				hasError = true;
			}
		} );
	}

	if ( ! hasError ) {
		disabledFields.forEach( field => {
			const $select = $(
				`.woocommerce-billing-fields .validate-required select[name="${ field }"], .woocommerce-shipping-fields .validate-required select[name="${ field }"]`
			);

			if ( $select.hasClass( 'qala-b2b-wholesale-disabled' ) ) {
				const $select2Container = $select.next( '.select2-container' );
				if ( $select2Container.length ) {
					$select2Container.addClass( 'qala-b2b-wholesale-disabled' );
					if ( ! $select.val() ) {
						hasError = true;
					}
				}
			}
		} );
	}

	if ( hasError ) {
		setCustomError(
			window?.QalaB2bWholesale?.text?.errorForCheckoutFields || 'Address incorrectly set. Please contact us to update your details.'
		);
	}
} );
